<template>
  <b-row id="loader-dots-v2" class="mb-0 p-0" role="status">
    <b-col class="p-0">
      <div class="cssload-dots">
        <div class="cssload-dot"></div>
        <div class="cssload-dot"></div>
        <div class="cssload-dot"></div>
        <div class="cssload-dot"></div>
        <div class="cssload-dot"></div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "LoaderDotsV2"
}
</script>

<style lang="scss">
#loader-dots-v2 {
  margin: 100px auto;
  z-index: 1;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
</style>